// Stamped by scripts/write-release.mjs when GITHUB_SHA is present. The
// committed value is the local and unit-test default. releaseVersion matches
// the Datadog sourcemap upload (`github.sha`).
export const releaseVersion = '37e958a34f040d93d699fd2bb62883cada5e65b4';
